















import Vue from "vue";
import Nav from "./Nav.vue";
import { mapMutations, mapState } from "vuex";
import {
  RootState,
  SET_QUESTIONNAIRE_STEP,
  SET_QUESTIONNAIRE_STEPS
} from "@/store/types";
export default Vue.extend({
  name: "Questionnaire",

  components: {
    Nav,
    AddressData: () => import("./Parts/AddressData.vue"),
    Question: () => import("./Parts/Question.vue"),
    FileUpload: () => import("./Parts/FileUpload.vue"),
    UserData: () => import("./Parts/UserData.vue")
  },

  created() {
    let steps;

    if (this.disableUserInput) {
      steps = [
        {
          order: 1,
          component: "AddressData"
        }
      ];
    } else if (!this.disableUserInput && this.disableFileUpload) {
      steps = [
        {
          order: 1,
          component: "AddressData"
        },
        ...this.questions,
        {
          order: this.questions.length + 2,
          component: "UserData"
        }
      ];
    } else {
      steps = [
        {
          order: 1,
          component: "AddressData"
        },
        ...this.questions,
        {
          order: this.questions.length + 2,
          component: "FileUpload"
        },
        {
          order: this.questions.length + 3,
          component: "UserData"
        }
      ];
    }

    this.setSteps(steps);
    this.setCurrentStep(this.steps[0].order);
  },

  computed: {
    ...mapState({
      currentStep: state => (state as RootState).currentQuestionnaireStep,
      steps: state => (state as RootState).questionnaireSteps,
      disableFileUpload: state => (state as RootState).survey.disableFileUpload,
      disableUserInput: state => (state as RootState).survey.disableUserInput
    }),

    questions(): Array<Record<string, any>> {
      if(typeof this.$store.state.survey.questions === "undefined"){
        return [];
      }
      const questions = this.$store.state.survey.questions;
      return questions.map((question, idx) => ({
        question,
        order: idx + 2,
        component: "Question"
      }));
    },

    activeComponent(): string {
      const step = this.steps.find(s => s.order === this.currentStep);

      if (step && {}.hasOwnProperty.call(step, "component")) {
        return step.component;
      }

      return null;
    },

    activeQuestion(): Record<string, any> | null {
      const questionObject = this.questions.find(
        q => q.order === this.currentStep
      );
      if (questionObject && questionObject.question) {
        return questionObject.question;
      }
      return null;
    }
  },

  methods: {
    ...mapMutations({
      setCurrentStep: SET_QUESTIONNAIRE_STEP,
      setSteps: SET_QUESTIONNAIRE_STEPS
    })
  }
});
